import {APPLICATIONS, VERSIONS, SETTINGS} from '../actionTypes'
import {asyncNames} from '../../lib/asyncUtil'
import {stateValue} from '../../lib/data'

const initialState = {loading: false, applications: [], versions: [], settings: [], failed: false, error: null, message: null}

const metadataReducer = (state = initialState, action) => {
  switch(action.type) {
    case asyncNames(APPLICATIONS).loading:
    case asyncNames(VERSIONS).loading:
    case asyncNames(SETTINGS).loading:
      return {...state, loading: action.data, error: null, failed: false}
    case asyncNames(APPLICATIONS).failure:
    case asyncNames(VERSIONS).failure:
    case asyncNames(SETTINGS).failure:
      return {...state, loading: false, error: action.data.error, failed: action.data.status}
    case asyncNames(APPLICATIONS).success:
      return {...state, loading: false, applications: stateValue({data: action.data, records: state.applications})}
    case asyncNames(VERSIONS).success:
      return {...state, loading: false, versions: stateValue({data: action.data, records: state.versions})}
    case asyncNames(SETTINGS).success:
      return {...state, loading: false, settings: stateValue({data: action.data, records: state.settings})}
    default:
      return state
  }
}

export default metadataReducer
